module.exports = __webpack_public_path__ + "img/首页banner2.3097a637.png";